import createComponent from '@carvana/merch-components/createComponent';

export const Card = createComponent('article', {
  className:
    'relative flex h-full flex-col gap-xl rounded-md border overflow-hidden border-border-subtle bg-background-default'
});

export const Vin = createComponent('p', {
  className: 'text-text-default t-body-xs px-xl py-md bg-background-weak'
});

export const Deltas = createComponent('div', {
  className: 'flex min-h-0 flex-1 flex-col gap-md px-xl max-h-full'
});

export const SelectionsLabel = createComponent('p', {
  className: 'text-text-strong t-heading-xs'
});

export const TrimHeading = createComponent('p', {
  className: 'text-text-strong t-heading-md px-xl'
});

export const IncludesAllRow = createComponent('div', {
  className: 'flex items-center gap-sm'
});

export const ConfettiOverlay = createComponent('img', {
  className:
    'pointer-events-none absolute bottom-[32.91px] left-[-1px] right-[-1.5px]'
});

export const PreOrderBadgeWrapper = createComponent('div', {
  className: 'pointer-events-none absolute left-xl top-xl z-10'
});

export const DeltaList = createComponent('ul', {
  className:
    'flex min-h-0 flex-1 list-disc list-outside flex-col gap-sm overflow-y-auto pl-2xl text-text-strong t-body-sm'
});

export const DeltaPrice = createComponent('span', {
  className: 'text-text-weak t-body-xs'
});

export const PriceSection = createComponent('div', {
  className: 'flex flex-col gap-sm border-t border-border-subtle pt-xl px-xl'
});

export const Price = createComponent('p', {
  className: 'text-text-strong t-heading-md'
});

export const Fulfillment = createComponent('div', {
  className: 'flex h-5 items-center gap-sm text-text-strong t-label-sm'
});

export const FulfillmentDot = createComponent('span', {
  className: 'size-[2px] shrink-0 rounded-full bg-text-strong'
});

export const GetItBy = createComponent('span', {
  className: 'text-text-strong t-label-sm'
});

export const DeltasCard = createComponent('div', {
  className:
    'absolute top-0 w-full rounded-t-md -translate-y-full bg-background-default py-xl overflow-hidden'
});
